import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/views/home/index.vue'
import notice from '@/views/notice/index.vue'
import { Message } from 'element-ui'
import store from '@/store/index'
import layout from '@/layout/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
    meta: {
      title: '首页',
      head: true
    }
  },
  {
    path: '/notice',
    name: 'notice',
    component: notice,
    meta: {
      title: '申请须知',
      head: false
    }
  },
  {
    path: '/infoRegister',
    name: 'infoRegister',
    component: () => import(/* webpackChunkName: "about" */ '@/views/infoRegister'),
    meta: {
      title: '信息注册',
      head: true
    }
  },
  // {
  //   path: '/branchApply',
  //   name: 'branchApply',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/branchApply'),
  //   meta: {
  //     title: '教学点申请',
  //     head: true
  //   }
  // },
  // {
  //   path: '/applySpeed',
  //   name: 'applySpeed',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/applySpeed/index'),
  //   meta: {
  //     title: '已申请信息管理',
  //     head: true
  //   }
  // },
  // {
  //   path: '/main',
  //   name: 'main',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/MainPage'),
  //   redirect: '/main/infoRegister',
  //   children: [
  //     {
  //       path: 'infoRegister',
  //       name: 'infoRegister',
  //       meta: {
  //         title: '信息注册',
  //         head: true,
  //         showNav: true
  //       },
  //       // component: () => import(/* webpackChunkName: "about" */ '@/views/homePage')
  //       component: () => import(/* webpackChunkName: "about" */ '@/views/infoRegister')
  //     },

  //   ]
  // },
  {
    path: '/application',
    name: 'application',
    component: layout,
    redirect: '/application/apply',
    meta: {
      title: '教学点申请',
      head: false
    },
    children: [
      {
        path: 'apply',
        name: 'apply',
        component: () => import('@/views/branchApply.vue'),
        meta: {
          title: '新点申请'
        }
      },
      {
        path: 'speedApply',
        name: 'speedApply',
        component: () => import('@/views/applySpeed/index.vue'),
        meta: {
          title: '申请信息管理'
        }
      }
    ]
  },

  {
    path: '*',
    name: '404',
    component: () => import('@/views/ErrorPage.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  if (to.path === '/') {
    sessionStorage.removeItem('userInfo')
    store.commit('removeUser')
    next()
  } else if (userInfo) {
    next()
  } else if (to.path === '/notice' || to.path === '/infoRegister') {
    next()
  }else {
    Message.error('请先登录！')
    sessionStorage.removeItem('userInfo')
    store.commit('removeUser')
    next('/')
  }
})

export default router
